
export default superclass => class extends superclass {
    dispatch(x) {
        this.sequencerEngine.dispatch(x);
    }
}
